export const defaultCustomerPortalCopy = {
    title: 'Customer Portal',
    profile: {
        subtitle: 'Company dashboard',
        loading: 'Loading company profile',
        unavailable: 'Company profile unavailable',
        logoFallbackLabel: '{company} logo placeholder',
        analysisLoadingTitle: 'Preparing operating analysis',
        analysisLoadingMessage: 'Loading the linked company profile before requesting analysis data.',
        analysisUnavailableTitle: 'Operating analysis unavailable',
        analysisUnavailableMessage: 'A linked company profile is required before operating analysis can load.',
        metrics: {
            totalVehicles: 'Total vehicles',
            operationalVehicles: 'Operational',
        },
    },
    sections: {
        operatingAnalysis: 'Operating Analysis',
        fleetOverview: 'Live Overview',
    },
    releaseNotes: {
        title: "We've been busy building",
        subtitle: 'Here are the latest updates ready for your fleet team.',
        closeLabel: 'Close release notes',
        markAllRead: 'Mark all read',
        gotIt: 'Got it',
        footerNote: 'Only customer-facing updates are shown here.',
        unreadLabel: 'Unread',
        pinnedLabel: 'Pinned',
        loadingDetail: 'Loading release details...',
        detailUnavailable: 'Release details could not load.',
        actionFailed: 'Could not mark releases read. Please try again.',
        imageAlt: 'Release preview',
    },
};

export const mergeCustomerPortalCopy = (copy = {}) => ({
    ...defaultCustomerPortalCopy,
    ...copy,
    profile: {
        ...defaultCustomerPortalCopy.profile,
        ...(copy.profile || {}),
        metrics: {
            ...defaultCustomerPortalCopy.profile.metrics,
            ...((copy.profile || {}).metrics || {}),
        },
    },
    sections: {
        ...defaultCustomerPortalCopy.sections,
        ...(copy.sections || {}),
    },
    releaseNotes: {
        ...defaultCustomerPortalCopy.releaseNotes,
        ...(copy.releaseNotes || {}),
    },
});
